export enum ExcludedReason {
  InsuredElsewhere = 'InsuredElsewhere',
  LicenseSuspendedRevoked = 'LicenseSuspendedRevoked',
  NeverLicensed = 'NeverLicensed',
  AwayAtSchool = 'AwayAtSchool',
  MilitaryDeployedOverseas = 'MilitaryDeployedOverseas',
  OutOfCountry = 'OutOfCountry',
  MovedOut = 'MovedOut',
  UnknownPerson = 'UnknownPerson',
}

export const ExcludedReasonOptions = [
  { label: 'Away at School', value: ExcludedReason.AwayAtSchool },
  { label: 'Insured Elsewhere', value: ExcludedReason.InsuredElsewhere },
  { label: 'License Suspended/Revoked', value: ExcludedReason.LicenseSuspendedRevoked },
  { label: 'Moved Out', value: ExcludedReason.MovedOut },
  { label: 'Never Licensed', value: ExcludedReason.NeverLicensed },
  { label: 'Out of Country', value: ExcludedReason.OutOfCountry },
];
